import React from "react";
/* eslint-disable */
import {
    Box, Card, Grid, CardContent, Divider, CardHeader,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

    render() {
        const Data = this.props.List;
        const searchQueryData = this.props.searchData;

        return (
            <div>

                {Data[0].cropid ? (
                    <>
                        <br />
                        <h4>   <center>  Demand and Supply (Productwise)</center></h4>
                        <br />
                        <h5>   <center>Product : {Data[0].productName} </center></h5>
                        <br /><br />
                        <Box minWidth={1050}>
                            <TableContainer style={{ marginLeft: '5px' }}>
                                <Table aria-label="caption table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align={'left'}>Product Name</TableCell>
                                            <TableCell align={'left'}>Date</TableCell>
                                            <TableCell align={'left'}>Demanded Quantity</TableCell>
                                            <TableCell align={'left'}>Supplied Qunatity</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Data.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.productName}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.date.split('T')[0]}
                                                </TableCell><TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.demandedQuantity}
                                                </TableCell><TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.suppliedQuantity}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </>
                ) : (
                    <>
                        <br />
                        <h4> <center>Demand and Supply (Farmerwise)</center></h4>
                        <br />
                        <h5>   <center> Farmer : {Data[0].firstName} </center></h5>
                        <br /><br />
                        <Box minWidth={1050}>
                            <TableContainer style={{ marginLeft: '5px' }}>
                                <Table aria-label="caption table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align={'left'}>Farmer Name</TableCell>
                                            <TableCell align={'left'}>Date</TableCell>
                                            <TableCell align={'left'}>Demanded Quantity</TableCell>
                                            <TableCell align={'left'}>Supplied Qunatity</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Data.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.firstName}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.date.split('T')[0]}
                                                </TableCell><TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.demandedQuantity}
                                                </TableCell><TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    {data.suppliedQuantity}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </>
                )
                }
            </div>
        );
    }
}
